// THIS FILE IS AUTOMATICALLY GENERATED BY SPACETIMEDB. EDITS TO THIS FILE
// WILL NOT BE SAVED. MODIFY TABLES IN YOUR MODULE SOURCE CODE INSTEAD.

/* eslint-disable */
/* tslint:disable */
import {
  TypeBuilder as __TypeBuilder,
  t as __t,
  type AlgebraicTypeType as __AlgebraicTypeType,
  type Infer as __Infer,
} from "spacetimedb";

export default __t.object("ServerNpc", {
  id: __t.u64(),
  spawnerId: __t.u64(),
  templateKey: __t.string(),
  tx: __t.u32(),
  tz: __t.u32(),
  goalTx: __t.u32(),
  goalTz: __t.u32(),
  hp: __t.u32(),
  maxHp: __t.u32(),
  biteDamage: __t.u32(),
});


